import {
  ApplicationDodMappedData,
  ApplicationMappedData,
  ApplicationProbeMappedData,
} from 'portfolio3/features/proforientation/model/selectors/applications';
import {
  ProforientationMappedDodData,
  ProforientationMappedEventData,
} from 'portfolio3/features/proforientation/model/selectors/events';
import {
  RecommendationDodMappedData,
  RecommendationExcursionMappedData,
  RecommendationProbeMappedData,
} from 'portfolio3/features/proforientation/model/selectors/recommendations';
import { getAcademicYearByDate, isDateValid } from 'utils';

import { splittedDataToSortedArray } from './splittedDataToSortedArray';
export const splitDataWithUnformattedEventDate = <
  T extends
    | ProforientationMappedDodData
    | ProforientationMappedEventData
    | ApplicationMappedData
    | ApplicationProbeMappedData
    | ApplicationDodMappedData
    | RecommendationProbeMappedData
    | RecommendationExcursionMappedData
    | RecommendationDodMappedData,
>(
  data: T[],
  academicYears: string[],
) => {
  const learningYearData: Record<string, T[]> = {};

  data.forEach((item) => {
    const date = new Date(item.unformattedEventDate);

    if (!isDateValid(date)) {
      return;
    }
    const period = getAcademicYearByDate(date);

    if (academicYears.includes(period)) {
      if (learningYearData[period]) {
        learningYearData[period].push(item);
      } else {
        learningYearData[period] = [item];
      }
    }
  });

  return splittedDataToSortedArray(learningYearData);
};
